import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import Header from '../landing/Header';
import Footer from '../landing/Footer';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const PaymentSuccessPage = () => {
  const { isEnglish, langPrefix } = useLanguage();
  const location = useLocation();

  // Content based on language
  const content = {
    fr: {
      title: 'Paiement confirmé',
      mainText: 'Merci pour votre paiement.',
      subText: 'Je vous contacte personnellement très rapidement sur WhatsApp afin de confirmer votre réservation et les derniers détails.',
      bullets: [
        'Acompte bien reçu',
        'Solde à régler sur place le jour de l\'excursion',
        'Aucun frais caché'
      ],
      reassurance: 'Vous n\'avez rien à faire de plus, je m\'occupe de tout.',
      backButton: 'Retour au site'
    },
    en: {
      title: 'Payment confirmed',
      mainText: 'Thank you for your payment.',
      subText: 'I will personally contact you shortly on WhatsApp to confirm your booking and final details.',
      bullets: [
        'Deposit received',
        'Remaining balance to be paid on the day of the excursion',
        'No hidden fees'
      ],
      reassurance: 'You don\'t need to do anything else, I take care of everything.',
      backButton: 'Back to website'
    }
  };

  const t = isEnglish ? content.en : content.fr;

  return (
    <div className="min-h-screen bg-gradient-to-b from-teal-50 to-white flex flex-col">
      <Header />
      
      <main className="flex-1 pt-24 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-lg mx-auto">
          {/* Success Card */}
          <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-10 text-center">
            {/* Success Icon */}
            <div className="flex justify-center mb-6">
              <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center">
                <CheckCircle className="w-12 h-12 text-emerald-500" />
              </div>
            </div>

            {/* Title */}
            <h1 className="text-2xl sm:text-3xl font-bold text-slate-800 mb-2">
              {t.title} <span className="text-emerald-500">✅</span>
            </h1>

            {/* Main Text */}
            <div className="mt-6 space-y-4">
              <p className="text-lg text-slate-700 font-medium">
                {t.mainText}
              </p>
              <p className="text-slate-600 leading-relaxed">
                {t.subText}
              </p>
            </div>

            {/* Info Bullets */}
            <div className="mt-8 bg-slate-50 rounded-xl p-5 text-left">
              <ul className="space-y-3">
                {t.bullets.map((bullet, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <span className="text-emerald-500 mt-0.5">•</span>
                    <span className="text-slate-600">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Reassurance Text */}
            <p className="mt-8 text-sm text-slate-500 italic">
              {t.reassurance}
            </p>

            {/* Back Button */}
            <div className="mt-8">
              <Button
                asChild
                className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 rounded-full text-base font-medium transition-all duration-300 hover:shadow-lg"
              >
                <Link to={langPrefix || '/'}>
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  {t.backButton}
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PaymentSuccessPage;
